<template>
  <div>
    <basic-container>
      <div>
        <el-form ref="form" :model="customerForm">
          <el-form-item label="动态参数配置">
            <el-table :data="tableData1" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">

              <el-table-column prop="parameterName" label="显示名称">
                <template slot-scope="scope">
                  <el-input type="input" name="parameterName" v-model="scope.row.parameterName"
                    :value="scope.row.parameterName" placeholder="请输入名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="currControlType" min-width="150" label="控件类型">
                <template slot-scope="scope">
                  <el-select name="currControlType" v-model="scope.row.currControlType" placeholder="请选择控件类型" clearable
                    @change="changeInputType(scope.row.currControlType, scope)" value-key="value">
                    <el-option v-for="item in currControlTypes" :key="item.value" :label="item.label" :value="item">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="datas" min-width="150" label="参数数据">
                <template slot-scope="scope">
                  <el-input type="textarea" name="datas"
                    v-if="scope.row.currControlType.value == 'RADIO' || scope.row.currControlType.value == 'CHECKBOX'"
                    v-model="scope.row.datas" :value="scope.row.datas" @blur="blurDataSource(scope)"
                    placeholder="请换行输入参数数据"></el-input>
                </template>
              </el-table-column>
              <!-- 排序 -->
              <el-table-column prop="sort" label="排序">
                <template slot-scope="scope">
                  <el-input type="input" name="sort" v-model="scope.row.sort" :value="scope.row.sort"
                    placeholder="请输入排序"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="120">

                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleStepping1Delete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column align="center" label="配置" width="150">
                <template slot-scope="scope">
                  <el-button type="success" icon="el-icon-plus" size="small"
                    @click="handleAdd1Rows(scope.$index, scope.row)">增加一行</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-button type="success" icon="el-icon-plus" size="small" style="margin: 20px 0"
                  @click="handleAdd1Rows()">增加一行</el-button>
              </template>
            </el-table>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
          <el-button type="primary" size="big" @click="submit">确定新增/修改</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import {
  findUsersAll,
  getDynamicParamConfig,
  saveDynamicParamConfig
} from "@/api/salesCloud/customerInfo";
export default {
  data() {
    return {
      customerForm: {},
      point: {},
      currIndex: {},
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      currservicePeoples: [],
      currControlTypes: DIC.CONTROL_TYPE,
      serviceCategory: {},
      serviceItem: {},
      tableData1: [],
    };
  },
  created() {
    this.getDynamicParamConfig();
  },
  methods: {
    /**
     * @description 动态参数配置回显
     */
    async getDynamicParamConfig() {
      let params = {};
      params.categoryId = this.serviceCategory.id;
      params.itemId = this.serviceItem.id;
      let res = await getDynamicParamConfig().then(res => {
        return JSON.parse(res.data);
      });
      console.log(res);
      let data = res;
      let tableData1 = [];
      //动态参数配置回显
      for (let i of data) {
        let obj = {};
        obj.currControlType = {};
        obj.currControlType.value = i.controlType;
        obj.dataSourceList = [];
        obj.dynamicCheckList = []; //多选
        obj.selectEngineer = {}; //单选服务工程师
        obj.selectEngineerList = []; //单选服务工程师
        obj.multipleSelectEngineer = {}; //多选服务工程师
        obj.multipleSelectEngineerList = []; //多选服务工程师
        obj.point = {}; //地址
        obj.fileList = []; //图片
        obj.id = i.id;
        obj.parameterName = i.parameterName;
        obj.dataSource = i.dataSource;
        obj.controlType = i.controlType;
        obj.rootDepartId = i.rootDepartId;
        obj.sort = i.sort;
        
        if (i.controlType == "RADIO") {
          obj.datas = i.dataSource;
          obj.dataSourceList = i.dataSource.split(/[(\r\n)\r\n]+/);
        }
        if (i.controlType == "CHECKBOX") {
          obj.datas = i.dataSource;
          obj.dataSourceList = i.dataSource.split(/[(\r\n)\r\n]+/);
          obj.dynamicCheckList = i.dynamicCheckList.split(","); //多选
        }
        tableData1.push(obj);
        this.tableData1 = tableData1;
      }

    },

    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    blurDataSource(scope) {
      if (scope.row.datas) {
        scope.row.dynamicList = scope.row.datas.split(/[(\r\n)\r\n]+/);
      }
    },
    changeInputType(type, scope) {
      if (type.value == "SELECT_ENGINEER") {
        let params = {};
        params.userType = "JOINS_ENGINEER";
        findUsersAll(params).then(res => {
          let data = JSON.parse(res.data);
          scope.row.selectEngineerList = data.rows;
        });
      }
      if (type.value == "MULTIPLE_SELECT_ENGINEER") {
        // scope.row.multipleSelectEngineer = [];
        let params = {};
        params.userType = "JOINS_ENGINEER";
        findUsersAll(params).then(res => {
          let data = JSON.parse(res.data);
          scope.row.multipleSelectEngineerList = data.rows;
        });
      }
    },
    submit() {
      let params = this.tableData1;
      console.log(params,'111');

      for (let i of params) {
        let currControlType = i.currControlType.value;
        i.controlType = currControlType;
        i.dataSource = i.datas;
        i.parameterData = i.datas;
      }
      console.log(params,'222');
      // 定义一个数组，用来存放参数"parameterName","controlType", "dataSource","sort"
      let arr = [];
      for (let i of params) {
        let obj = {};
        obj.parameterName = i.parameterName;
        obj.controlType = i.controlType;
        obj.dataSource = i.dataSource;
        obj.sort = i.sort;
        arr.push(obj);
      }
      console.log(arr,'333');
      //params是一个数组，表单验证，"parameterName","controlType", "dataSource","sort"不能为空
      for (let item of arr) {
        if (!item.parameterName) {
          this.$message({
            showClose: true,
            message: "显示名称不能为空",
            type: "error"
          });
          return;
        }
        if (!item.controlType) {
          this.$message({
            showClose: true,
            message: "控件类型不能为空",
            type: "error"
          });
          return;
        }
        if (item.controlType == "RADIO" || item.controlType == "CHECKBOX") {
          if (!item.dataSource) {
            this.$message({
              showClose: true,
              message: "参数数据不能为空",
              type: "error"
            });
            return;
          }
        }
        if (!item.sort) {
          this.$message({
            showClose: true,
            message: "排序不能为空",
            type: "error"
          });
          return;
        }
      }
      saveDynamicParamConfig(arr).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
        }else{
          this.$message({
            showClose: true,
            message: "操作失败",
            type: "error"
          });
        }
      });
    },
    handleStepping1Delete(index) {
      this.tableData1.splice(index, 1);
    },
    handleAdd1Rows() {
      let list = {
        currControlType: {},
        dataSourceList: [], //参数数据列表
        dynamicCheckList: [], //多选
        selectEngineer: {},
        multipleSelectEngineer: {},
        point: {},
        multipleSelectEngineerList: [],
        selectEngineerList: [],
        fileList: [],
        data: {}
      };
      this.tableData1.push(list);
    },

    handleRemove(file, fileList) {
      for (let item of this.tableData1) {
        for (let i of item.fileList) {
          if (i.uid == file.uid) {
            item.fileList = fileList;
          }
        }
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    isIndex(row, index) {
      this.currIndex.index = index;
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      var obj = {};
      obj.name = option.file.name;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            // this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            obj.url = array[0];
            this.tableData1[this.currIndex.index].fileList.push(obj);
            //上传多张图片
            if (this.tableData1[this.currIndex.index].image == undefined) {
              this.tableData1[this.currIndex.index].image = array[0];
            } else {
              let aa = "";
              this.tableData1[this.currIndex.index].image = aa.concat(
                this.tableData1[this.currIndex.index].image,
                ",",
                array[0]
              );
            }
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style lang="scss"></style>